//cspell:disable
import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from './Useletter';
import Foter from './Foter';
function Women() {
  return (
    <div>
       <Container>
      <Row>
        <Col xs={12} sm={6} md={4} lg={3}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-1.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/W-C-17.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
         <Col xs={12} sm={6} md={4} lg={3}><img src="https://www.junaidjamshed.com/media/wysiwyg/W-C-6.jpg" style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }} alt="" /></Col>
        <Col xs={12} sm={6} md={4} lg={3}><img src="https://www.junaidjamshed.com/media/wysiwyg/W-C-8.jpg" alt=""
        style={{
          width:'100%',
          height:'auto',
          objectFit:'cover',
           marginTop: '90px'
      }} /></Col>
      
      </Row>
      </Container>
      {/* <Container>
      <Row>
        <Col xs={12} sm={6} md={4} lg={3}><img src="https://www.junaidjamshed.com/media/wysiwyg/W-C-6.jpg" style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }} alt="" /></Col>
        <Col xs={12} sm={6} md={4} lg={3}><img src="https://www.junaidjamshed.com/media/wysiwyg/W-C-8.jpg" alt=""
        style={{
          width:'100%',
          height:'auto',
          objectFit:'cover',
           marginTop: '90px'
      }} /></Col>
        <Col xs={12} sm={6} md={4} lg={3}><img src="https://www.junaidjamshed.com/media/wysiwyg/W-C-10.jpg" alt="" 
        style={{
          width:'100%',
          height:'auto',
          objectFit:'cover',
           marginTop: '90px'
      }}/></Col>
      </Row>
    </Container> */}
    {/* <br /><br /> */}
    <p>TRENDY KURTIS</p>
    <hr />
    {/* <br /><br /> */}
    <Container>
      <Row>
        <Col xs={12} sm={6} md={4} lg={3}>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/w/jws-24-3073_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   }} /> </div>
   <br /><br />
   <div className="hiding"><p>BLUE CAMBRIC PRINTED KURTI <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
   </div>
   
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/w/jws-24-3070_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/w/jws-24-3072_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>YELLOW CAMBRIC PRINTED 

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/w/jws-24-3071_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED  <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
       
      </Row>
    </Container>

    <p>ACCESSERIES <hr /></p>
    <Container>
      <Row>
        <Col xs={12} sm={6} md={4} lg={3}>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/l/jlt-24-8045_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   }} /> </div>
   <br /><br />
   <div className="hiding"><p>BLUE CAMBRIC PRINTED KURTI <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
   </div>
   
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/l/jlt-24-8044_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/l/jlt-24-8043_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>YELLOW CAMBRIC PRINTED 

 <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/l/jlt-24-8041_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED  <br />
   <b>PKR 2,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
       
      </Row>
    </Container>
   

      <p>FRAGRANCE <hr /></p>

      <Container>
      <Row>
        <Col xs={12} sm={6} md={4} lg={3}>
        <div className="box-content">
        <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/b/l/bloom-01_1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   }} /> </div>
   <br /><br />
   <div className="hiding"><p>BLUE CAMBRIC PRINTED KURTI <br />
   <b>PKR 1,890.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
   </div>
   
        </Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/p/o/pour-femme-j._1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
   <b>PKR 1,890.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/b/o/bottle_1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>YELLOW CAMBRIC PRINTED 

 <br />
   <b>PKR 1,890.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>
        <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/a/janan_pour_femme_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
   alt=''style={{height:'250px', width:'100%',
   
   }} /></div>
    <br /><br />
   <div className="hiding"><p>BROWN CAMBRIC PRINTED  <br />
   <b>PKR 1,590.00</b>
   </p>
   </div>
   <div className="d">
   <div id="d1">XS</div>
   <div id="d1">S</div> 
   <div id="d1">M</div>
    <div id="d1">L</div>
     <div id="d1">XL</div>
   </div> <br></br>
   <button className='bag'> ADD TO BAG</button>
</div></Col>

      </Row>
    </Container>

    <Container>
      <Row>
        <Col >
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/makeup_25.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
            //  marginTop: '0px'

        }}/>
        </Col>
        
      </Row>
      </Container>
      <Useletter/>
      <Foter/>
   
    </div>
  )
}

export default Women
